import { Button, Input, Tabs, Typography } from 'antd'
import { useState } from 'react'
import Template from '../../Template'
import BgProfile from '../../assets/profile-bg.jpg'
import Member from '../../assets/profile.jpg'
import { CustomInput } from '../../components'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import { profileSchema } from '../../Validations/profileVlidation'
import { useEffect } from 'react'



const Profile = () => {

    const items = [
        { label: 'Edit profile', key: 'item-1', children: <EditProfile /> },
        { label: 'Login History', key: 'item-2', children: 'Login History' },

    ];
    return (
        <Template
            headerTitle={['My profile']}
        >
            <Tabs items={items} style={{ marginBottom: 70 }} />

        </Template>
    )
}

export default Profile

export function EditProfile() {
    const [profileValues, setProfileValues] = useState({ email: '', password: '', name: '', position: '' })


    const { register, handleSubmit, formState: { errors } } = useForm({
        resolver: yupResolver(profileSchema),
    });
    const onSubmit = (data) => {
        console.log(data)
    }
    const onChange = (e) => {
        const { value, name } = e.target
        setProfileValues(prev => ({ ...prev, [name]: value }))
    }
    return (
        <>
            <div className='flex_space_between'
                style={{
                    borderRadius: '8px',
                    width: '100%',
                    height: 256,
                    backgroundImage: `url(${BgProfile})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    padding: '0 40px',
                    opacity: '75%'
                }}>
                <div style={{ display: 'flex', gap: 20 }}>
                    <img src={Member} height={128} width={120} style={{ borderRadius: '100%' }} alt="" />
                    <div className='flex_ver_center '>
                        <Typography.Title style={{ color: '#FCFCFC' }} level={3}> Jovelle</Typography.Title>
                        <Typography.Title style={{ color: '#FCFCFC' }} level={5}> Supervisor</Typography.Title>
                        <Typography.Title style={{ color: '#FCFCFC' }} level={5}> jovelle@kingsley.edu.my</Typography.Title>
                    </div>
                </div>

            </div>
            <div className='profile_form' style={{ margin: '80px 0' }}>
                <form onSubmit={handleSubmit(onSubmit)} >

                    <div className='profile_input' style={{ display: 'flex', gap: 20, flexWrap: 'wrap', marginBottom: 30 }}>
                        <CustomInput value={profileValues.name} onChange={onChange} register={register} error={errors} type='text' name="name" label='Name' required width='100%' minWidth={320} />
                        <CustomInput value={profileValues.position} onChange={onChange} type='text' name="position" label='Position' width='100%' minWidth={320} />
                        <CustomInput value={profileValues.email} onChange={onChange} register={register} error={errors} type='text' name="email" label='Email' required width='100%' minWidth={320} />
                        <CustomInput value={profileValues.password} onChange={onChange} register={register} error={errors} type='password' name="password" label='Password' required width='100%' minWidth={320} />
                    </div>
                    <Button type="primary" htmlType="submit" style={{ background: '#1A99CA', borderRadius: 8, width: 320, height: 56 }}>Save</Button>
                </form>
            </div>

        </>
    )
}